"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgMiniBar = function SvgMiniBar(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4D4D4D",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.656 4.333V2.529h2.27v1.769a3 3 0 0 0 .368 1.44l.322.588c.452.827.69 1.755.69 2.698v5.467a1 1 0 0 1-1 1h-3.01a1 1 0 0 1-1-1v-5.34a6 6 0 0 1 .674-2.762l.35-.675a3 3 0 0 0 .336-1.381zm.214-.423h2.024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.206 8.17h-2.562v5.417h2.562M4.483 9.532v4.092M3.5 5.5h3v2h-3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.516 10.501h2.98a1 1 0 0 1 1 1v.03a1 1 0 0 1-1 1H7.98l1.55-.002a.952.952 0 1 1 0 1.905H7.98h1.515a1 1 0 0 1 1 .999v.076a1 1 0 0 1-1 1H7.98h1.524a.99.99 0 0 1 0 1.982H6.507a.99.99 0 1 1 0-1.982H7.98l-1.455.005a1 1 0 0 1-1.003-1v-1.987a1 1 0 0 1 1-1H7.99 6.517a1 1 0 0 1-1-1V11.5a1 1 0 0 1 1-1z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgMiniBar);
var _default = exports["default"] = Memo;